// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
  white-space: pre-line;
  line-height: 1.5;
}

.dont-show-checkbox {
  display: block;
  margin-top: 16px;
}

.text-input {
  display: block;
  width: 100%;
  min-width: 320px;
  box-sizing: border-box;
  margin-top: 8px;
  padding: 8px 10px;
  font: inherit;
  color: inherit;
  background: rgba(127, 127, 127, 0.12);
  border: 1px solid rgba(127, 127, 127, 0.4);
  border-radius: 4px;
  outline: none;
}
.text-input:focus {
  border-color: #f4ac39;
}`, "",{"version":3,"sources":["webpack://./src/app/components/confirm-dialog/confirm-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;AACF;AACE;EACE,qBAAA;AACJ","sourcesContent":[".message {\n  white-space: pre-line;\n  line-height: 1.5;\n}\n\n.dont-show-checkbox {\n  display: block;\n  margin-top: 16px;\n}\n\n.text-input {\n  display: block;\n  width: 100%;\n  min-width: 320px;\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding: 8px 10px;\n  font: inherit;\n  color: inherit;\n  background: rgba(127, 127, 127, 0.12);\n  border: 1px solid rgba(127, 127, 127, 0.4);\n  border-radius: 4px;\n  outline: none;\n\n  &:focus {\n    border-color: #f4ac39;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
